let googleScriptPromise;

export function loadGoogleScript() {
    if (window.google?.accounts?.id) {
        return Promise.resolve();
    }

    if (!googleScriptPromise) {
        googleScriptPromise = new Promise((resolve, reject) => {
            const existing = document.querySelector(
                'script[src="https://accounts.google.com/gsi/client"]'
            );

            if (existing) {
                existing.addEventListener("load", resolve);
                existing.addEventListener("error", reject);
                return;
            }

            const script = document.createElement("script");
            script.src = "https://accounts.google.com/gsi/client";
            script.async = true;
            script.defer = true;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }

    return googleScriptPromise;
}
